module.exports = __webpack_public_path__ + "static/img/bg_hidden.c477a46e.svg";